import React from 'react';

const SettingsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
      <p>Settings page coming soon...</p>
    </div>
  );
};

export default SettingsPage;